module.exports = __webpack_public_path__ + "img/ulga-logo-bw.40648502.png";